import script from "./ProductImages.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductImages.vue?vue&type=script&setup=true&lang=js"

import "./ProductImages.vue?vue&type=style&index=0&id=16f4ecdc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f4ecdc"]])

export default __exports__